import React from "react"

import PackagesSectionDesktop from "./PackagesSectionDesktop"
import PackagesSectionMobile from "./PackagesSectionMobile"

const PackagesSection = ({
  section,
  practice,
  theme,
  highlightedField,
  pageSlug,
  viewMode = "",
  deviceType = "desktop"
}) => {
  // If viewMode is explicitly set (from preview), use that to determine which component to show
  if (viewMode === "mobile") {
    return (
      <PackagesSectionMobile
        section={section}
        practice={practice}
        theme={theme}
        highlightedField={highlightedField}
        pageSlug={pageSlug}
      />
    )
  }

  if (viewMode === "desktop") {
    return (
      <PackagesSectionDesktop
        section={section}
        practice={practice}
        theme={theme}
        highlightedField={highlightedField}
        pageSlug={pageSlug}
      />
    )
  }

  // Use server-side device detection for public pages
  if (deviceType === "mobile") {
    return (
      <PackagesSectionMobile
        section={section}
        practice={practice}
        theme={theme}
        highlightedField={highlightedField}
        pageSlug={pageSlug}
      />
    )
  }

  // Default to desktop for desktop devices
  return (
    <PackagesSectionDesktop
      section={section}
      practice={practice}
      theme={theme}
      highlightedField={highlightedField}
      pageSlug={pageSlug}
    />
  )
}

export default PackagesSection
